import { render, staticRenderFns } from "./EditTopicForAllDialog.vue?vue&type=template&id=632a383c"
import script from "./EditTopicForAllDialog.ts?vue&type=script&lang=ts&external"
export * from "./EditTopicForAllDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./EditTopicForAllDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports